import {
  useQuery,
  useMutation,
  useQueryClient,
  keepPreviousData,
} from "@tanstack/react-query";
import { auditService } from "../services/svc_audits";
import { queryKeys } from "../lib/queryKeys";
import { ListRequest } from "../types/common/commonTypes";

export const useTSQAuditList = (params: ListRequest, enabled: boolean) => {
  return useQuery({
    queryKey: queryKeys.audit.list(params),
    queryFn: () => auditService.list(params),
    placeholderData: keepPreviousData,
    enabled: enabled,
  });
};

export const useTSQRecordHistory = (
  table: string,
  id: string,
  enabled: boolean,
) => {
  return useQuery({
    queryKey: queryKeys.audit.record(table, id),
    queryFn: () => auditService.getRecordHistory(table, id),
    placeholderData: keepPreviousData,
    enabled: enabled,
  });
};

export const useTSQUserHistory = (id: string, enabled: boolean) => {
  return useQuery({
    queryKey: queryKeys.audit.user(id),
    queryFn: () => auditService.getUserHistory(id),
    placeholderData: keepPreviousData,
    enabled: enabled,
  });
};
